// Helpers para filtros compuestos en endpoints de alquileres.
// Los IDs aceptan valor único, lista separada por comas o array.
// El backend ignora silenciosamente parámetros mal formados.

const toCsv = (value) => {
  if (value == null) return undefined;
  if (Array.isArray(value)) {
    const cleaned = value.filter((v) => v != null && v !== '');
    return cleaned.length ? cleaned.join(',') : undefined;
  }
  const str = String(value).trim();
  return str === '' ? undefined : str;
};

/**
 * Construye un objeto con los query params soportados por
 * /rentals/admin/active, /rentals/admin/dashboard y /rentals/admin/reports/payments-excel.
 * Solo incluye claves con valor (axios omite undefined).
 *
 * Filtros aceptados:
 *   sellerId, propertyId, officeId, rentalId, status, currency  -> string | string[]
 *   dateFrom, dateTo                                            -> 'YYYY-MM-DD'
 *   dateField                                                   -> 'dueDate' | 'paymentDate'
 */
export const buildRentalFilterParams = (filters = {}) => {
  const params = {
    sellerId: toCsv(filters.sellerId),
    propertyId: toCsv(filters.propertyId),
    officeId: toCsv(filters.officeId),
    rentalId: toCsv(filters.rentalId),
    status: toCsv(filters.status),
    currency: toCsv(filters.currency),
    dateFrom: filters.dateFrom || undefined,
    dateTo: filters.dateTo || undefined,
    dateField: filters.dateField || undefined,
  };
  Object.keys(params).forEach((k) => {
    if (params[k] === undefined) delete params[k];
  });
  return params;
};

export default buildRentalFilterParams;
